import {bootboxConfirm} from "../../backend/before";

const EditProfile = () => {
    const main = document.getElementById('edit-profile');

    if (!main) return;

    const element =  {
        btnImg: $('.profile-card__avatar img'),
        inputAvatar: $("#input-avatar")
    };

    element.btnImg.click(function (e) {
        element.inputAvatar.trigger('click');
    });

    element.inputAvatar.change(function (e) {
        const reader = new FileReader();
        reader.onload = function(event) {
            const contents = event.target.result;
            element.btnImg.attr('src', contents);
        };

        reader.onerror = function(event) {
            console.error("File could not be read! Code " + event.target.error.code);
        };

        reader.readAsDataURL(e.target.files[0]);
    });
};

$(() => {
    EditProfile();
});
